import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { DirectDebitService } from 'src/app/services/direct-debit/direct-debit.service';
import { mobiscroll, MbscDatetimeOptions, MbscFormOptions } from '@mobiscroll/angular';
import { DatePipe } from '@angular/common';
import { saveAs } from 'file-saver';

mobiscroll.settings = {
  lang: 'es',
  theme: 'ios',
  themeVariant: 'light',
};
const now = new Date();
let week = [ new Date() ,new Date()];

@Component({
  selector: 'app-direc-debit-alliances-history',
  templateUrl: './direc-debit-alliances-history.component.html',
  styleUrls: ['./direc-debit-alliances-history.component.css'],
  providers: [DatePipe]
})
export class DirecDebitAlliancesHistoryComponent implements OnInit {

  range: Array < Date > = week;
  d1: any;
  d2: any;
  allie: any;
  type: any;
  loading = false;
  historic_list: any = [];

  types: any = [{
    "id": 1,
    "name": "Diario",
  },{
    "id": 2,
    "name": "Masivo",
  },{
    "id": 3,
    "name": "Morosos",
  }];

  statuses: any = [{
    "id": 'INITIAL',
    "name": "Sin comenzar",
  },{
    "id": "GENERATED",
    "name": "El archivo de carga másiva fue generado",
  },{
    "id": "DOWNLOADED",
    "name": "El archivo de carga másiva ha sido descargado",
  },{
    "id": "UPLOADED",
    "name": "El archivo ya fue cargado en el banco y se encuentra en espera de respuesta",
  },{
    "id": "PROCESING",
    "name": "Se recibió la respuesta del banco y se encuentra procesando",
  }
  ,{
    "id": "FINISHED",
    "name": "El proceso se finalizó y ya se realizó la conciliación",
  }];

  allies: any = [];

  dateSetting: MbscDatetimeOptions = {
    lang: 'es',
    theme: 'ios',
    themeVariant: 'light',
    max:now,
    responsive: {
      small: {
          controls: ['calendar'],
          display: 'center'
      },
      medium: {
          display: 'bubble',
      }
  }
  
  };

  form: FormGroup | any = this.formBuilder.group(
    {
      allie: [''],
      type: ['']
    }
  );
  
  constructor(    
    private formBuilder: FormBuilder,
    private userService: UserService,
    private datePipe: DatePipe,
    private directDebitService: DirectDebitService
  ) { }

  birthdaySet = () => {

  }

  

  async ngOnInit() {
    this.allies = await this.getAllies();
    this.allies = this.allies.res;
    this.setDefault();
    this.updateCurrentDirectDebit();
  }

  setDefault = () => {
    if(this.allies.length===1) {
      this.form.get('allie').setValue(this.allies[0].code);
      this.form.get('allie').patchValue(this.allies[0].code);
    }
    if(this.types.length>=1) {
      this.form.get('type').setValue(this.types[0].id);
      this.form.get('type').patchValue(this.types[0].id);
    }
  }

  getAllies = async () => {
    return await this.userService.getAllies({});
  };

  


  updateCurrentDirectDebit = async () => {
    this.d1 = this.datePipe.transform(this.range[0], 'MM/dd/yyyy');
    this.d2 = this.datePipe.transform(this.range[1], 'MM/dd/yyyy');
    this.allie = this.form.get('allie').value;
    this.type = this.form.get('type').value;

    this.getHistoric();
  }

  getHistoric = async () => {
    let body = {
      allie: this.allie,
      type: this.type,
      from: this.d1,
      to: this.d2
    };
    this.historic_list = await this.directDebitService.historic_aaliances(body);
    if(this.historic_list) {
      this.historic_list = this.historic_list.resp;
    }
  }

  getDescriptionStatus = (value: string) => {
    let response = this.statuses.find((row: any)=> {
      return row.id===value;
    });
    return response.name;
  }

  downloadFile = async (url:any, extension: string, name: string) => {
    let res = await this.directDebitService.downloadImage(url, extension);
    if(res) {
      saveAs(res, `${name}.${extension}`);
    }
  }


}
